const myUser = JSON.parse(window.localStorage.getItem('LocalSession'));
const permisos = myUser?.permisos?.$values;

export const isAllowed = (permisoId) => {
    return permisos ? permisos.some( p => p.id === permisoId ) : false;
}
